import setMetaTagsFromRouter from '@/helpers/router/setMetaTagsFromRouter'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

type User = {
  permissions: string[]
}
export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
  user: User | null
) => {
  const userPermissions = user && user.permissions
  const routeWithPermission = to.matched.find((record) => record.meta.permission)
  if (routeWithPermission != null) {
    const routePermission = routeWithPermission.meta?.permission as string | string[]
    if (Array.isArray(routePermission)) {
      if (routePermission.some((permission) => userPermissions?.includes(permission))) {
        return setMetaTagsFromRouter(to, from, next)
      }
      const routeToRedirect = from.name === 'Login' ? 'Home' : (from.name ?? 'Home')
      return next({ name: routeToRedirect })
    }
    if (userPermissions?.includes(routePermission)) {
      return setMetaTagsFromRouter(to, from, next)
    }

    const routeToRedirect = from.name === 'Login' ? 'Home' : (from.name ?? 'Home')
    return next({ name: routeToRedirect })
  }
  return false
}
